import PropTypes from 'prop-types';
import React, { useState } from 'react';

const PrintIcon = ({ theme }) => {
  const [color, setColor] = useState('#66737E');

  return (
    <svg
      fill="none"
      height="23"
      onMouseOut={() => {
        setColor('#66737E');
      }}
      onMouseOver={() => {
        if (theme === 'ak529') {
          setColor('#520F9A');
        } else if (theme === 'md529') {
          setColor('#ED8B00');
        } else {
          setColor('#006894');
        }
      }}
      viewBox="0 0 25 23"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M5.81555 17.1953H2.81555C1.71555 17.1953 0.815552 16.2953 0.815552 15.1953V9.19531C0.815552 8.09531 1.71555 7.19531 2.81555 7.19531H21.8156C22.9156 7.19531 23.8156 8.09531 23.8156 9.19531V15.1953C23.8156 16.2953 22.9156 17.1953 21.8156 17.1953H18.8156"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M5.81555 5.19531V1.19531H15.8156L18.8156 4.19531V5.19531"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M18.8156 14.1953H5.81555V22.1953H18.8156V14.1953Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M3.81555 11.1953C4.36784 11.1953 4.81555 10.7476 4.81555 10.1953C4.81555 9.64303 4.36784 9.19531 3.81555 9.19531C3.26327 9.19531 2.81555 9.64303 2.81555 10.1953C2.81555 10.7476 3.26327 11.1953 3.81555 11.1953Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M7.81555 16.1953H16.8156"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M7.81555 18.1953H16.8156"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M7.81555 20.1953H16.8156"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
        <path
          d="M15.8156 1.19531V4.19531H18.8156"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            fill="white"
            height="22"
            transform="translate(0.315552 0.695312)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

PrintIcon.propTypes = {
  theme: PropTypes.string
};

export default PrintIcon;
